import { getContainingComponent } from "ceres/app/helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");

import TranslationService from "ceres/app/services/TranslationService";

import { Swiper } from "swiper";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import html2pdf from "html2pdf.js";
// import domtoimage from "dom-to-image-improved";
import { debounce } from "ceres/app/helper/debounce";
import Vue from "vue";
import { getStyle } from "ceres/app/helper/dom";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";

import { isNullOrUndefined } from "ceres/app/helper/utils";
import { getCookie } from "~/app/helper/Cookie";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector) {
    headerCollapses.push(selector);
    $(document).ready(function() {
        $(selector).on("show.bs.collapse", () => {
            headerCollapses.forEach(element => {
                if (!$(element).is(selector)) {
                    $(element).collapse("hide");
                }
            });
        });

    });
}


function CeresMain() {
    const browser = browserDetect.detect();

    if (browser && browser.name) {
        $("html").addClass(browser.name);
    } else {
        $("html").addClass("unkown-os");
    }

    // Detect Facebook integrated Browser
    if (typeof navigator !== "undefined" && /FBA[NV]\/([0-9\.]+)/.test(navigator.userAgent)) {
        document.body.classList.add("facebook");
    }

    $(window).scroll(function() {
        if ($(".wrapper-main").hasClass("isSticky")) {
            if ($(this).scrollTop() > 1) {
                $(".wrapper-main").addClass("sticky");
            } else {
                $(".wrapper-main").removeClass("sticky");
            }
        }
        // handle single item sticky widget
        if ($(".single-sticky__wrapper").length) {
            if ($(this).scrollTop() > 800) {
                $(".single-sticky__wrapper").addClass("single-sticky__wrapper--show");
            } else {
                $(".single-sticky__wrapper").removeClass("single-sticky__wrapper--show");
            }
        }

        if ($(this).scrollTop() > 300) {
            $(".helper-tools__back-to-top").addClass("visible");
        } else {
            $(".helper-tools__back-to-top").removeClass("visible");
        }

    });


    window.onpopstate = function(event) {
        if (event.state && event.state.requireReload) {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    $("[data-toggle=\"tooltip\"]").tooltip();

    HeaderCollapse("#countrySettings");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $toggleListView = $(".toggle-list-view");
    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    $(document).on("click", function(evt) {
        const basketOpenClass = (App.config.basket.previewType === "right") ? "open-right" : "open-hover";

        if ($("#vue-app").hasClass(basketOpenClass)) {
            if ($(evt.target).attr("class") === "category-filter__close" || $(evt.target).closest("button").attr("class") === "category-filter__close") {
                evt.preventDefault();
                $("#vue-app").toggleClass(basketOpenClass || "open-hover");
                $(".wrapper-inner.category-filter__sidebar").hide();
                $(".wrapper-inner.basket-preview").show();
            } else if ((evt.target !== $(".basket-preview")) && (evt.target !== document.querySelector(".basket-preview-hover")) && (evt.target.classList[0] !== "message") && ($(evt.target).parents(".basket-preview").length <= 0 && $(evt.target).parents(".basket-preview-hover").length <= 0) && ($(evt.target).parents(".category-filter__sidebar").length <= 0)) {
                evt.preventDefault();
                $("#vue-app").toggleClass(basketOpenClass || "open-hover");
                $(".wrapper-inner.category-filter__sidebar").hide();
                $(".wrapper-inner.basket-preview").show();
            }

        } else if ($(evt.target).attr("id") === "toggleFilterSidebar") {

            evt.preventDefault();
            $("#vue-app").toggleClass(basketOpenClass || "open-hover");
            $(".wrapper-inner.category-filter__sidebar").show();

            $(".wrapper-inner.basket-preview").hide();
        }

        headerCollapses.forEach(element => {
            if (evt.target !== element && $(evt.target).parents(element).length <= 0) {
                $(element).collapse("hide");
            }
        });
    });

    $toggleListView.on("click", function(evt) {
        evt.preventDefault();

        // toggle it's own state
        $toggleListView.toggleClass("grid");

        // toggle internal style of thumbs
        $(".product-list, .cmp-product-thumb").toggleClass("grid");
    });

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function() {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function() {
        $(".main").off("click", closeNav);
    });

    function closeNav() {
        $("#mainNavbarCollapse").collapse("hide");
    }

    let originalImagesArray = [];

    $(document).ready(function() {
        if (window.navigator.userAgent.match(/MSIE|Trident/)) {
            $("#ie-info-modal").modal("show");
        }

        const isMobile = window.matchMedia("(max-width: 768px)").matches;
        const isScreenXs = window.matchMedia("(max-width: 576px)").matches;

        const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (iOS) {
            $("body").addClass("is-ios");
        }

        const ua = navigator.userAgent.toLowerCase();

        if (ua.indexOf("safari") !== -1) {
            if (ua.indexOf("chrome") > -1) {
                // Chrome
            } else {
                $("body").addClass("is-safari");
            }
        }

        if (window.innerWidth < 768 && $(".single").length > 0) {
            $("[data-toggle=\"tooltip\"]").tooltip();
        }

        // erster commit im document.ready beim initialen Laden der App
        vueApp.$store.commit("setViewPortSize", window.innerWidth);

        window.addEventListener("resize", function() {
            // Weitere Commits bei Resize:
            vueApp.$store.commit("setViewPortSize", window.innerWidth);

            // fix tablet megamenü klick
            if (window.innerWidth < 1200) {
                $(".mainmenu__second-level-link, .mainmenu__third-level-link").click(function() {
                    window.location.href = $(this).attr("href");
                });
            }
        });

        /* $('.thumb-swiper__container .swiper-slide').click(function(){
            $('.thumb-swiper__container .swiper-slide').removeClass("swiper-slide-active");
            $(this).addClass('swiper-slide-active');
        });*/

        let flag = false;

        $(".single-information-widget__pdf").click(function() {

            window.dataLayer.push({ "event": "pdf" });

            $(".single-information-widget__pdf").addClass("loading");
            // vueApp.$store.commit("setShowPdfContainer", true);
            vueApp.$store.commit(`${vueApp.$store.getters.currentItemVariation.item.id}/setShowPdfContainer`, true);

            const date = new Date();

            const dd = date.getDate();

            let mm = date.getMonth() + 1;

            if (mm < 10) {
                mm = "0" + mm;
            }
            const yyyy = date.getFullYear();

            let hh = date.getHours();

            if ((hh).toString().length === 1) {
                hh = "0" + hh;
            }
            let min = date.getMinutes();

            if ((min).toString().length === 1) {
                min = "0" + min;
            }
            let ss = date.getSeconds();

            if ((ss).toString().length === 1) {
                ss = "0" + ss;
            }

            const dateTime = dd + "." + mm + "." + yyyy + " " + hh + ":" + min + ":" + ss;

            $(".time-for-pdf").text(dateTime);

            if (!flag) {
                $(".single-attributes__value-img-wrapper img").each(function(index, item) {
                    $(item).attr("src", window.location.origin + $(item).attr("src"));
                });
            }

            setTimeout(function() {

                if ($(".single-attributes__teaser-text").length) {
                    // $('.single-attributes-for-pdf').before("<div class=\"html2pdf__page-break\"></div>");
                    $(".single-attributes-for-pdf").html($(".single-attributes").html());
                    /* $('.single-attributes-for-pdf').before("<div class='html2pdf__page-break' id='attributes-page-break'></div>");
                    if($("#attributes-page-break").prev(".html2pdf__page-break").length > 0){
                        $("#attributes-page-break").prev(".html2pdf__page-break").remove();
                    }*/
                } else {
                    $(".single-attributes-for-pdf").remove();
                }

                const images = [];

                $("#dynamicJSWrapper img").each(function(index, item) {
                    if (!$(item).hasClass("pdf-container-for-canvas__img")) {
                        $(item).before("<div class=\"html2pdf__page-break\"></div>");
                    }
                    images.push($(item).attr("src"));
                });

                if (!flag) {
                    originalImagesArray = images;
                }

                $("#dynamicJSWrapper p, .single p").each(function(index, item) {
                    if ($(item).html() === "") {
                        $(item).remove();
                    }
                });

                // $('.dynamic-pdf-desc h3').before('<div class="html2pdf__page-break"></div>');
                $.ajax({
                    url: window.location.origin + "/rest/abfallbehaelter/category",
                    // type: "POST",
                    async: true,
                    data: {
                        images: originalImagesArray, type: "base64"
                    }, success: function(data, textStatus, jqXHR) {

                        let response = JSON.parse(data);

                        response = response.data;

                        $("#dynamicJSWrapper img").each(function(index, item) {
                            $(item).attr("src", response[index]);
                        });

                        if ($(".html2pdf__page-break").next(".html2pdf__page-break").length > 1) {
                            $(".html2pdf__page-break").nextAll(".html2pdf__page-break").remove();
                        }

                        const element = document.getElementById("dynamicJSWrapper");

                        if (flag) {
                            html2pdf().set({
                                margin: [35, 20, 8, 20],
                                filename: "Datenblatt.pdf",
                                image: { type: "jpg", quality: 0.75 },
                                html2canvas: { dpi: 120, letterRendering: true, useCORS: true },
                                jsPDF: {
                                    unit: "mm",
                                    format: "a4",
                                    orientation: "portrait"
                                } /* pagebreak: {mode: ['css', 'legacy'], avoid: 'p'}*/
                            })
                                .from(element).toPdf().get("pdf").then(function(pdf) {
                                // Your code to alter the pdf object.

                                    // const numberOfPages = pdf.internal.getNumberOfPages();
                                    const pdfPages = pdf.internal.pages;

                                    const width = pdf.internal.pageSize.getWidth();

                                    // pdf.addImage(singleImg, "JPG", 10, 30);
                                    for (let i = 1; i < pdfPages.length; i++) {
                                        pdf.setPage(i);
                                        pdf.setFontSize(8).text(dateTime, 165, 293);
                                        // pdf.addHTML($(".time-for-pdf")[0], 150, 293);
                                        if (i < pdfPages.length) {
                                        // -1
                                            pdf.addImage("data:image/png;base64,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", "PNG", 0, 10, width, 15);
                                        }
                                    }
                                }).save();

                            $(".single-information-widget__pdf").removeClass("loading");

                            // vueApp.$store.commit("setShowPdfContainer", false); TODO
                        } else {
                            html2pdf().set({
                                margin: [35, 20, 8, 20],
                                filename: "Datenblatt.pdf",
                                image: { type: "jpg", quality: 0.75 },
                                html2canvas: { dpi: 120, letterRendering: true, useCORS: true },
                                jsPDF: {
                                    unit: "mm",
                                    format: "a4",
                                    orientation: "portrait"
                                } /* pagebreak: {mode: ['css', 'legacy'], avoid: 'p'}*/
                            })
                                .from(element).toPdf().get("pdf").then(function(pdf) {
                                // Your code to alter the pdf object.

                                    // const number_of_pages = pdf.internal.getNumberOfPages();
                                    const pdfPages = pdf.internal.pages;

                                    const width = pdf.internal.pageSize.getWidth();

                                    // pdf.addImage(singleImg, "JPG", 10, 30);
                                    for (let i = 1; i < pdfPages.length; i++) {
                                        pdf.setPage(i);
                                        // pdf.addHTML($(".time-for-pdf")[0], 150, 293);
                                        if (i < pdfPages.length - 1) {
                                            pdf.addImage("data:image/png;base64,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", "PNG", 0, 10, width, 15);
                                        }
                                    }
                                });

                            flag = true;

                            // vueApp.$store.commit("setShowPdfContainer", false);
                            vueApp.$store.commit(`${vueApp.$store.getters.currentItemVariation.item.id}/setShowPdfContainer`, true);
                            setTimeout(function() {
                                $(".single-information-widget__pdf").trigger("click");
                            }, 5000);

                        }

                    }, error: function(data) {
                        console.log(data);
                    }
                });

            }, 100);

        });

        if (!isMobile) {
            $(".mainmenu").mouseover(function() {
                if (!$("#vue-app").hasClass("main-hover-dark")) {
                    $("#vue-app").addClass("main-hover-dark");
                }
            });
            $(".mainmenu").mouseleave(function() {
                $("#vue-app").removeClass("main-hover-dark");
            });

        }

        $(".helper-tools__help").click(function() {
            $(".helper-tools__help-content").toggleClass("helper-tools__help-content--active");
        });


        if ($(".two-image-slide-widget__swiper").length > 0) {
            // const twoSlides =
            new Swiper(".two-image-slide-widget__swiper", {
                slidesPerView: 2, spaceBetween: 30, loadPrevNext: true, breakpoints: {
                    768: {
                        slidesPerView: 1, spaceBetween: 30
                    }
                }, navigation: {
                    nextEl: ".two-image-slide-widget__next", prevEl: ".two-image-slide-widget__prev"
                }, pagination: {
                    el: ".two-image-slide-widget__pagination", type: "bullets"
                }
            });
        }

        if ($(".home-first-swiper__swiper").length > 0) {
            // const swiperFirst =
            new Swiper(".home-first-swiper__swiper", {
                pagination: {
                    el: ".home-first-swiper__pagination", type: "bullets"
                }, lazy: true, loadPrevNext: true, autoplay: {
                    delay: 6000
                }, loop: true, navigation: {
                    nextEl: ".home-first-swiper__next", prevEl: ".home-first-swiper__prev"
                }, on: {
                    init: function() {
                        $(".home-first-swiper__swiper").addClass("is-initialized");
                    }
                }
            });
        }

        if ($(".category-list-swiper__swiper").length > 0) {

            if (!isScreenXs) {
                // const catSwiper =
                new Swiper(".category-list-swiper__swiper", {
                    slidesPerView: 3,
                    // 5
                    spaceBetween: 10, breakpoints: {
                        835: {
                            slidesPerView: 5,
                            // 3
                            spaceBetween: 10
                        }
                    }, pagination: {
                        el: ".category-list-swiper__pagination", type: "fraction"
                    }, navigation: {
                        nextEl: ".category-list-swiper__next", prevEl: ".category-list-swiper__prev"
                    }
                });
            }
        }

        if ($(".credentials-widget__swiper").length > 0) {
            // const credentialsSwiper =
            new Swiper(".credentials-widget__swiper", {
                slidesPerView: 1, spaceBetween: 30, pagination: {
                    el: ".credentials-widget__pagination", type: "fraction"
                }, navigation: {
                    nextEl: ".credentials-widget__next", prevEl: ".credentials-widget__prev"
                }
            });
        }

        if ($(".accordion-widget--hide-xs").length > 0) {
            if (window.matchMedia("(max-width: 576px)").matches) {
                $(this).find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                $(this).find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                $(".accordion-widget__slot").click(function(ev) {
                    $(this).toggleClass("accordion-widget__slot--hide");
                    $(this).find(".accordion-widget__headline").addClass("accordion-widget__headline--is-open");
                });

            }
        }

        if ($(".accordion-widget--hide-sm").length > 0) {
            if (window.matchMedia("(max-width: 768px)").matches) {
                $(".accordion-widget--hide-sm").find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                $(".accordion-widget--hide-sm").find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                $(".accordion-widget__headline").click(function(ev) {
                    $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
                    $(this).toggleClass("accordion-widget__headline--is-open");
                });
            }
        }

        if ($(".accordion-widget--hide-md").length > 0) {
            if (window.matchMedia("(max-width: 992px)").matches) {
                $(".accordion-widget--hide-md").find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                $(".accordion-widget--hide-md").find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                /* $(".accordion-widget__headline").click(function (ev) {
                    $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
                    $(this).toggleClass("accordion-widget__headline--is-open");
                });*/
            }
        }

        if ($(".accordion-widget--hide-lg").length > 0) {
            if (window.matchMedia("(max-width: 1200px)").matches) {
                $(".accordion-widget--hide-lg").find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                $(".accordion-widget--hide-lg").find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                $(".accordion-widget__headline").click(function(ev) {
                    $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
                    $(this).toggleClass("accordion-widget__headline--is-open");
                });
            }
        }

        /* function doOnOrientChange(){
            if ($(".accordion-widget--hide-md").length > 0){
                if (window.matchMedia("(max-width: 992px)").matches){
                    $(".accordion-widget--hide-md").find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                    $(".accordion-widget--hide-md").find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                    $(".accordion-widget__headline").unbind("click");
                    $(".accordion-widget__headline").off("click").click(function (ev) {
                        $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
                        $(this).toggleClass("accordion-widget__headline--is-open");
                    });
                }
            }
            if ($(".accordion-widget--hide-lg").length > 0){
                if (window.matchMedia("(max-width: 1200px)").matches){
                    $(".accordion-widget--hide-lg").find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                    $(".accordion-widget--hide-lg").find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                    $(".accordion-widget__headline").unbind("click");
                    $(".accordion-widget__headline").off("click").click(function (ev) {
                        $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
                        $(this).toggleClass("accordion-widget__headline--is-open");
                    });
                }
            }
        }
        window.addEventListener('orientationchange', doOnOrientChange);*/

        $(document).on("click", ".accordion-widget__headline", function() {
            $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
            $(this).toggleClass("accordion-widget__headline--is-open");
        });

        if ($(".single-sub-nav-widget").length > 0) {
            $("body").on("click", ".single-sub-nav-widget__item", function(ev) {
                // todo: navigation funktioniert noch nicht für alle Punkte
                // todo: Offset genau kalkulieren

                if ($(this).attr("sub-nav-scroll-to") === "2" || $(this).attr("sub-nav-scroll-to") == "3") {
                    $("html, body").animate({
                        scrollTop: $(".accordion-widget--scroll-to-" + $(this).attr("sub-nav-scroll-to")).offset().top - 270
                    }, "slow");
                } else {
                    $("html, body").animate({
                        scrollTop: $(".scroll-to-" + $(this).attr("sub-nav-scroll-to")).offset().top - 270
                    }, "slow");
                }
            });
        }

        if ($(".invoice-addresses-select .salutation-select").length > 0) {
            $(".invoice-addresses-select .salutation-select").parent().parent().removeClass("col-sm-4");
        }


        if ($(".single-sticky__variations").length > 0) {
            $("body").on("click", ".single-sticky__variations", function(ev) {

                $("html, body").animate({
                    scrollTop: $(".scroll-to-" + $(this).attr("sub-nav-scroll-to")).offset().top - 270
                }, "slow");
            });
        }

        if ($(".single-sticky__offer-wrapper").length > 0) {
            $("body").on("click", ".single-sticky__offer-wrapper button", function(ev) {

                $("html, body").animate({
                    scrollTop: $(".scroll-to-" + $(this).attr("sub-nav-scroll-to")).offset().top - 270
                }, "slow");
            });
        }

        if ($(".content__navigation-list").length > 0) {

            $(".content__navigation-li").click(function(ev) {

                $("html, body").animate({
                    scrollTop: $("." + $(this).find("span").attr("nav-scroll-to")).offset().top - 270
                }, "slow");
            });
        }

        // eslint-disable-next-line no-unused-vars
        function findGetParameter(parameterName) {
            let result = null;

            let tmp = [];

            const items = location.search.substr(1).split("&");

            for (let index = 0; index < items.length; index++) {
                tmp = items[index].split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            }
            return result;
        }

        function findCampaign(campaignString) {
            let urlArray = window.location.href.split("?");

            if (urlArray.length > 1) {
                urlArray = urlArray[1].split("&");

                for (const key in urlArray) {
                    const tmp = urlArray[key].split("=");

                    if (tmp[1] == campaignString) {
                        return true;
                    }
                }
                return false;
            } else {
                return false;
            }

        }

        /* if(findGetParameter(App.campaign1) != null || findGetParameter(App.campaign2) != null || findGetParameter(App.campaign3) != null ||
            findGetParameter(App.campaign4) != null || findGetParameter(App.campaign5) != null){
            sessionStorage.setItem('campaignActive', 'true');
            vueApp.$store.commit("getSessionStorage");
        }*/

        if (sessionStorage.getItem("campaignActive") === null) {
            if (findCampaign(App.campaign1) || findCampaign(App.campaign2) || findCampaign(App.campaign3) || findCampaign(App.campaign4) || findCampaign(App.campaign5)) {
                sessionStorage.setItem("campaignActive", "true");
                vueApp.$store.commit("getSessionStorage");
            }
        } else {
            vueApp.$store.commit("getSessionStorage");
        }

        $(".mainmenu__first-level-item").click(function(ev) {
            if ($("body").hasClass("touch")) {
                ev.preventDefault();
                $(this).trigger("mouseover");
            }
        });

        // $(".mainmenu__link.mainmenu__link--has-child").mouseover(function () {
        //     $(".mainmenu__first-level .mainmenu__first-level-item:first-child").addClass("active-level");
        // });

        $(".mainmenu__first-level-item").mouseover(function() {
            $(".mainmenu__first-level-item").removeClass("active-level");
            $(this).addClass("active-level");
        });

        let offerOrigin = "";

        // INFO: special feature fuer sascha
        $("[data-target=\"#offer\"]").on("click", function() {

            if ($(this).closest(".single-button-widget__offer-wrapper").length) {
                offerOrigin = "product";
            } else {
                offerOrigin = "header";
            }

            if ($(this)[0].dataset.message) {

                const msgParts = [];

                const dataSetDesc = $(this)[0].dataset.custom;
                const variationName = vueApp.$store.getters.currentItemVariation.texts.name1;
                const variationId = vueApp.$store.getters.currentItemVariation.variation.id;
                const variationAttributes = vueApp.$store.getters[vueApp.$store.getters.currentItemVariation.item.id + "/currentSelectedAttributesAsString"];

                if (dataSetDesc) {
                    msgParts.push(dataSetDesc);
                }

                if (variationName) {
                    msgParts.push(variationName);
                }

                if (variationId) {
                    msgParts.push(variationId);
                }

                if (variationAttributes) {
                    msgParts.push(variationAttributes);
                }

                const variationInfo = msgParts.join(", ");

                $("#offer-modal-wrapper .offer__input[name=\"variation_id\"]").val(variationId);

                const msg = `Sehr geehrte Damen und Herren,
            
bitte erstellen Sie uns ein Angebot über folgendes Produkt

${variationInfo}

Gewünschte Produktmenge: .........
Lieferadresse: .........
Telefonnummer für Rückfragen (Optional): .........

Vielen Dank!`;

                $("#offer-modal-wrapper .offer__input[name=\"message\"]").val(msg);
            }
        });

        $("#js--offer__send").on("click", function(ev) {
            ev.preventDefault();

            $(".has-error").removeClass("has-error");

            let isAllFilled = true;

            $.each($("#offer-modal-wrapper .offer__input[required]"), function(index, item) {
                if ($(item).val() === "" && $(item).attr("type") !== "checkbox") {
                    $(item).addClass("has-error");
                    isAllFilled = false;
                } else if ($(item).attr("type") === "checkbox" && $(item).prop("checked") === false) {
                    $(item).closest(".form-check").find("label").addClass("has-error");
                    isAllFilled = false;
                }
            });

            if (isAllFilled) {

                const mailObj = {
                    name: $("#offer-modal-wrapper .offer__input[name=\"name\"]").val(),
                    message: $("#offer-modal-wrapper .offer__input[name=\"message\"]").val(),
                    userMail: $("#offer-modal-wrapper .offer__input[name=\"email\"]").val(),
                    variationId: $("#offer-modal-wrapper .offer__input[name=\"variation_id\"]").val(),
                    subject: "xx"
                };

                const gaId = getCookie("_ga");

                if (!isNullOrUndefined(gaId)) {
                    mailObj.gaId = gaId;
                }

                $.ajax({
                    url: window.location.origin + "/rest/abfallbehaelter/customer/contact/mail",
                    type: "POST",
                    async: true,
                    data: {
                        contactData: mailObj, template: "AbfallbehaelterXXL::Customer.Components.Contact.ContactMail"
                    },
                    success: function(data, textStatus, jqXHR) {
                        $("#offer").modal("hide");

                        NotificationService.success(TranslationService.translate("Ceres::Template.contactSendSuccess")).closeAfter(10000);

                        if (offerOrigin === "product") {
                            dataLayer.push({ "event": "Offer requests_product_card" });
                        } else {
                            dataLayer.push({ "event": "Offer requests_head" });
                        }

                    },
                    error: function(data) {
                    }
                });

            }
        });

        $("#resetPwd .btn-primary").click(function() {
            dataLayer.push({ "event": "password_recovery" });
        });

        // add spans to sidebar links
        if ($(".widget-navigation-tree").length) {
            $(".widget-navigation-tree > .widget-inner > ul > li > a").each(function(index, item) {
                const text = $(item).text();

                $(item).html("<span>" + text + "</span>");
            });

            document.querySelector(".widget-navigation-tree").classList.add("is-visible");
        }

        const offset = 250;
        const duration = 300;

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function() {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput) {
                searchInput.focus();
            }
        });

        window.addEventListener("scroll", function() {
            if (isDesktop) {
                if ($(window).scrollTop() > offset) {
                    $(".back-to-top").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                } else {
                    $(".back-to-top").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }
            }
        }, detectPassiveEvents() ? { passive: true } : false);

        window.addEventListener("resize", function() {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").click(function(event) {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $(".back-to-top-center").click(function(event) {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").click(function() {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function() {
            this.dispatchEvent(new CustomEvent("updateStickyContainer", {
                bubbles: true
            }));
        });

        // fix tablet megamenü klick
        if (window.innerWidth < 1200) {
            $(".mainmenu__second-level-link, .mainmenu__third-level-link").click(function() {
                window.location.href = $(this).attr("href");
            });
        }

        // basket tracking
        $("a[href='" + App.urls.basket + "']").click(function(ev) {
            ev.preventDefault();

            dataLayer.push({
                "event": "checkout", "ecommerce": {
                    "checkout": {
                        "actionField": { "step": 1, "option": "Basket view" }
                    }
                }, "eventCallback": function() {
                    document.location = App.urls.basket;
                }, "eventTimeout": 2000
            });
        });

        // search results
        if (App.isSearch) {

            const ids = [];

            $(".product-list li").each(function(index, item) {
                ids.push($(item).find(".thumb-overlay__text--bg span").text());
            });

            dataLayer.push({
                // Product ID  if there are several products, send an array, for example ['1599', '1599']
                "event": "DR", "ecomm_pagetype": "searchresults", "ecomm_prodid": ids
            });
        }

        // home
        if (App.isHome) {

            dataLayer.push({
                // Product ID  if there are several products, send an array, for example ['1599', '1599']
                "event": "DR", "ecomm_pagetype": "home", "ecomm_prodid": ""
            });

        }

        $("a[href=\"/checkout-ceres\"]").click(function() {

        });

        $(".page-singleitem .widget-item-list-caption").click(function() {
            if (window.innerWidth < 991) {
                $(this).closest(".widget-item-list").find(".row").toggleClass("itemlist-visible");
                $(this).toggleClass("is-open");
            }
        });

        /* if($('.page-confirmation').length > 0){
            if($('.cmp-totals .font-weight-bold').text().indexOf("Netto") > 0){
                $('.cmp-totals').addClass("is-net");
            }
        }*/

    });

    // scroll animations

    document.addEventListener("DOMContentLoaded", function() {

        // add items with shopbuilder animate class
        const sbAnimElements = [].slice.call(document.querySelectorAll(".anim"));

        sbAnimElements.forEach(el => {
            el.classList.add("animate");
            el.classList.remove("anim");
        });


        const animationElements = [].slice.call(document.querySelectorAll(".animate"));

        if ("IntersectionObserver" in window) {
            const animationObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        const el = entry.target;

                        el.classList.add("animating");
                        // el.classList.remove("animate")
                    }
                });
            });

            animationElements.forEach(function(el) {
                animationObserver.observe(el);
            });
        } else {
            animationElements.forEach(function(entry) {
                const el = entry.target;

                el.classList.remove("animate");
            });
        }
    });

    document.addEventListener("DOMContentLoaded", function() {
        let lazyImages = [].slice.call(document.querySelectorAll(".payment__icon img[data-src]"));

        let active = false;

        const lazyLoad = function() {
            if (active === false) {
                active = true;

                setTimeout(function() {
                    lazyImages.forEach(function(lazyImage) {
                        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
                            lazyImage.src = lazyImage.dataset.src;
                            delete lazyImage.dataset.src;

                            lazyImages = lazyImages.filter(function(image) {
                                return image !== lazyImage;
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener("scroll", lazyLoad);
                                window.removeEventListener("resize", lazyLoad);
                                window.removeEventListener("orientationchange", lazyLoad);
                            }
                        }
                    });

                    active = false;
                }, 200);
            }
        };

        document.addEventListener("scroll", lazyLoad);
        window.addEventListener("resize", lazyLoad);
        window.addEventListener("orientationchange", lazyLoad);
    });

    document.addEventListener("DOMContentLoaded", function() {
        const lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

        if ("IntersectionObserver" in window) {
            const lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        entry.target.style["backgroundImage"] = entry.target.dataset.background;
                        entry.target.classList.remove("lazy-background");
                        lazyBackgroundObserver.unobserve(entry.target);
                    }
                });
            });

            lazyBackgrounds.forEach(function(lazyBackground) {
                lazyBackgroundObserver.observe(lazyBackground);
            });
        }
    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event) {
    if (event.detail.type) {
        switch (event.detail.type) {
        case "info":
            NotificationService.info(event.detail.message);
            break;
        case "log":
            NotificationService.log(event.detail.message);
            break;
        case "error":
            NotificationService.error(event.detail.message);
            break;
        case "success":
            NotificationService.success(event.detail.message);
            break;
        case "warning":
            NotificationService.warn(event.detail.message);
            break;
        default:
            console.log("no type such as:" + event.detail.type);
            break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

let headerParent = document.querySelector("[data-header-offset]");

if (headerParent) {
    let headerLoaded = false;

    let allHeaderChildrenHeights = [];

    let headerHeight = 0;

    // Calculate top offset for vue-app node because header is not part of document flow
    function calculateBodyOffset() {
        headerParent = headerParent.offsetParent ? headerParent : document.querySelector("[data-header-offset]");

        if (headerLoaded && headerParent) {
            const vueApp = document.getElementById("vue-app");

            vueApp.style.marginTop = headerHeight + "px";
            vueApp.style.minHeight = "calc(100vh - " + headerHeight + "px)";
        }
    }

    // Set descending z-index for all header elements and create list of elements with unfixed class for later use
    function prepareHeaderElements() {
        if (headerLoaded && !App.isShopBuilder) {
            headerParent = headerParent.offsetParent ? headerParent : document.querySelector("[data-header-offset]");

            let zIndex = 100;

            for (let i = 0; i < headerParent.children.length; i++) {
                const elem = headerParent.children[i];

                elem.style.zIndex = zIndex;
                zIndex--;
            }
        }
    }

    // Collect heights of header elements for later use
    function getHeaderHeights() {
        headerParent = headerParent.offsetParent ? headerParent : document.querySelector("[data-header-offset]");

        allHeaderChildrenHeights = [];

        headerHeight = 0;

        for (let i = 0; i < headerParent.children.length; i++) {
            const elementHeight = headerParent.children[i].getBoundingClientRect().height;

            allHeaderChildrenHeights.push(elementHeight);
            headerHeight += elementHeight;
        }
    }

    // Scroll header elements depending on if they are unfixed or not
    // eslint-disable-next-line no-unused-vars
    function scrollHeaderElements() {
        if (headerLoaded && !App.isShopBuilder) {
            headerParent = headerParent.offsetParent ? headerParent : document.querySelector("[data-header-offset]");

            let absolutePos = 0;

            let fixedElementsHeight = 0;

            let offset = 0;

            const scrollTop = window.pageYOffset;

            for (let i = 0; i < headerParent.children.length; i++) {
                const elem = headerParent.children[i];
                const elemHeight = allHeaderChildrenHeights[i];

                offset = absolutePos - scrollTop;
                elem.style.position = "absolute";

                // Element is unfixed and should scroll indefinetly
                if (elem.classList.contains("unfixed")) {
                    elem.style.top = offset + "px";
                } else {
                    // Element is fixed and should scroll until it hits top of header or next fixed element

                    if (offset < 0) {
                        elem.style.top = 0;
                    } else {
                        elem.style.top = offset + "px";
                    }

                    if (fixedElementsHeight > 0 && offset < fixedElementsHeight) {
                        elem.style.top = fixedElementsHeight + "px";
                    }

                    fixedElementsHeight = fixedElementsHeight + elemHeight;
                }
                absolutePos = absolutePos + elemHeight;
            }
        }
    }

    window.addEventListener("resize", debounce(function() {
        getHeaderHeights();
        calculateBodyOffset();
        // scrollHeaderElements();
    }, 50));

    window.addEventListener("load", function() {
        getHeaderHeights();
        calculateBodyOffset();
        prepareHeaderElements();
        // scrollHeaderElements();

        let timeout;

        window.addEventListener("scroll", function() {
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }

            // timeout = window.requestAnimationFrame(scrollHeaderElements);

        }, detectPassiveEvents() ? { passive: true } : false);
    });

    if (document.fonts) {
        document.fonts.onloadingdone = function(evt) {
            getHeaderHeights();
            calculateBodyOffset();
            prepareHeaderElements();
            // scrollHeaderElements();
        };
    }

    $(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function() {
        calculateBodyOffset();
        $(".owl-carousel").trigger("refresh.owl.carousel");
    });

    const headerImages = headerParent.querySelectorAll("img");

    Promise.all(Array.prototype.slice.call(headerImages).map(function(headerImage) {
        return new Promise(function(resolve) {
            if (headerImage.complete) {
                resolve();
            } else {
                headerImage.onload = function() {
                    resolve();
                };
                headerImage.onerror = function() {
                    resolve();
                };
            }
        });
    })).then(function() {
        // Initialize
        headerLoaded = true;
        getHeaderHeights();
        calculateBodyOffset();
        // scrollHeaderElements();
    });

    // calculateBodyOffset();
}

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement) {
    const parent = widgetElement[1];

    const parentComponent = getContainingComponent(parent);

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] });
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount(widgetElement[0]);
    $(component.$el).find("*").each(function(index, elem) {
        $(elem).click(function(event) {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function() {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes() {
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el => {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex)) {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
